import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useRef } from 'react';
import { PaperclipAttachment } from '../../icons/essentials';
import { getTestIds } from '../../utils/TestIds';
import { CircularLoader } from '../CircularLoader';
import { CloseButton } from '../CloseButton';
import { InfoIcon } from '../InfoIcon';
import { Row } from '../Layout/Row';
import { TextButton } from '../TextButton';
import { Typography } from '../Typography';
import styles from './FileUpload.module.scss';
import { toBiProps } from './FileUpload.utils';
export const GetFileUploadTID = (parentTestId)=>getTestIds(parentTestId);
export const FileUpload = (props)=>{
    const { file, accept, uploadLabel, helpTooltip, isUploading, disabled, multiple, onFileSelected, onRemove, testId } = props;
    const { FileUploadTestIds } = useMemo(()=>GetFileUploadTID(testId), [
        testId
    ]);
    const fileInputRef = useRef(null);
    const openFilePicker = ()=>{
        var _fileInputRef_current;
        (_fileInputRef_current = fileInputRef.current) === null || _fileInputRef_current === void 0 ? void 0 : _fileInputRef_current.click();
    };
    const handleFileChange = (event)=>{
        var _event_target_files;
        const picked = Array.from((_event_target_files = event.target.files) !== null && _event_target_files !== void 0 ? _event_target_files : []);
        (multiple ? picked : picked.slice(0, 1)).forEach((file)=>onFileSelected(file));
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    const showTrigger = file == null && !isUploading;
    return /*#__PURE__*/ _jsxs(Row, {
        gap: 4,
        alignItems: "center",
        testId: FileUploadTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx("input", {
                ref: fileInputRef,
                type: "file",
                accept: accept,
                multiple: multiple,
                className: styles.hiddenInput,
                onChange: handleFileChange,
                "data-testid": FileUploadTestIds.Input()
            }),
            showTrigger && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(TextButton, _object_spread_props(_object_spread({}, toBiProps(props, (bi)=>bi.upload)), {
                        testId: FileUploadTestIds.Trigger(),
                        underline: "none",
                        weight: "normal",
                        prefixIcon: /*#__PURE__*/ _jsx(PaperclipAttachment, {}),
                        disabled: disabled,
                        onClick: openFilePicker,
                        children: uploadLabel
                    })),
                    helpTooltip != null && /*#__PURE__*/ _jsx(InfoIcon, {
                        info: helpTooltip,
                        size: "s",
                        testId: FileUploadTestIds.HelpIcon()
                    })
                ]
            }),
            file != null && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    file.url != null ? /*#__PURE__*/ _jsx(TextButton, _object_spread_props(_object_spread({}, toBiProps(props, (bi)=>bi.view)), {
                        as: "a",
                        href: file.url,
                        target: "_blank",
                        rel: "noreferrer",
                        testId: FileUploadTestIds.FileName(),
                        weight: "normal",
                        variant: "paragraph1",
                        children: file.name
                    })) : /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        testId: FileUploadTestIds.FileName(),
                        children: file.name
                    }),
                    file.sizeLabel != null && /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        skin: "secondary",
                        testId: FileUploadTestIds.FileSize(),
                        children: "(".concat(file.sizeLabel, ")")
                    })
                ]
            }),
            isUploading && /*#__PURE__*/ _jsx(CircularLoader, {
                size: 16,
                testId: FileUploadTestIds.Loader()
            }),
            file != null && !isUploading && /*#__PURE__*/ _jsx(CloseButton, _object_spread_props(_object_spread({}, toBiProps(props, (bi)=>bi.remove)), {
                skin: "transparent",
                size: "small",
                testId: FileUploadTestIds.RemoveButton(),
                onClick: onRemove
            }))
        ]
    });
};
